import { TranslateService } from '@ngx-translate/core'

import { APP_INJECTOR } from 'app.module'
import { BaseDecorator } from './base.decorator'
import { Session } from 'models'

export class SessionDecorator extends BaseDecorator {
  private translateService: TranslateService

  constructor(protected object: Session) {
    super(object)

    this.translateService = APP_INJECTOR.get(TranslateService)
  }

  state(): string {
    if (this.object.isExamStarted()) {
      let state = this.translateService.instant('sessions.states.exam_started')
      if (this.object.examStartedAt) {
        state += `, начат ${ this.object.examStartedAt.format('DD.MM.YY HH:mm') }`
      }
      return state
    } else {
      return this.object.state ? this.translateService.instant('sessions.states.' + this.object.state) : null
    }
  }

  approvalState(): string {
    return this.object.approvalState ? this.translateService.instant('sessions.approvalStates.' + this.object.approvalState) : null
  }

  moderatorApprovalState(): string {
    return this.object.moderatorApprovalState ? this.translateService.instant('sessions.moderatorApprovalStates.' + this.object.moderatorApprovalState) : null
  }

  videaccessorApprovalState(): string {
    let va = this.object.videoaccessor
    let vaState = this.object.videoaccessorApprovalState
    let vaStateName =  vaState ? this.translateService.instant(`sessions.videoaccessorApprovalStates.${vaState}`) : null
    let vaFullName = va ? `${va.firstname} ${va.lastname}` : null

    if (vaFullName && vaStateName) {
      return `${vaFullName}: ${vaStateName}`
    }
    else if (!va && this.object.videoaccessorAutoapproved){
      return this.translateService.instant(`sessions.videoaccessorApprovalStates.videaccessor_autoapprove`)
    }
    else if (!va){
      return vaStateName
    }
    return null
  }

  interviewerApprovalState(): string {
    let interviewer = this.object.interviewer
    let interviewerState = this.object.interviewState
    let interviewerStateName =  interviewerState ? this.translateService.instant(`sessions.interviewStates.${interviewerState}`) : null
    let vaFullName = interviewer ? `${interviewer.firstname} ${interviewer.lastname}` : null

    if (vaFullName && interviewerStateName) {
      return `${vaFullName}: ${interviewerStateName}`
    }
    else if (!interviewer){
      return interviewerStateName
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/decorators/session.decorator.ts